import React, { useState} from "react";
import Slider from 'react-slick';

const LayoutTab = ({ handleLayoutChange, selectedLayout,updateBusinessHoursTabData,businessHoursTabData }) => {
    //Custom With
    const [isWidthPanelOpen, setIsWidthPanelOpen] = useState(false);
    const [isFullWidth, setIsFullWidth] = useState(Boolean(businessHoursTabData.layout_is_full_width));
    const [customWidth, setCustomWidth] = useState(businessHoursTabData.layout_custom_width || 1200);
    const toggleWidthPanel = () => setIsWidthPanelOpen(prev => !prev);
    const [activeAlignmentSection, setActiveAlignmentSection] = useState(businessHoursTabData.position_alignment);

    //Layout Style Images 
    const headerReviewSliderImages = [
        `${process.env.PUBLIC_URL}/business-hours/layout-style/business-hours.png`,
        `${process.env.PUBLIC_URL}/business-hours/layout-style/business-hours.png`,
    ];

    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 2000,
    };

    //Custom With Hander start
    const handleFullWidthToggle = (e) => {
        const checked = e.target.checked;
        setIsFullWidth(checked);
        updateBusinessHoursTabData('layout_is_full_width', checked);
    
        if (checked) {
            updateBusinessHoursTabData('layout_custom_width', customWidth);
        } else {
            updateBusinessHoursTabData('layout_custom_width', 1200);
            setCustomWidth(1200);
        }
    };
    
    const handleSliderChange = (e) => {
        const newValue = parseInt(e.target.value, 10);
        setCustomWidth(newValue);
        updateBusinessHoursTabData('layout_custom_width', newValue);
    };
    //Custom With Hander End

    // Handle Position Alignment change
    const handleActiveAlignmentInputChange = (event) => {
        setActiveAlignmentSection(event.target.value);
        updateBusinessHoursTabData("position_alignment", event.target.value);
    };

    return (
        <div className="testimonials-side-baar-layout-tab">
            <span>Layout</span>
            <div className="layout-box-all">
                <div className="card h-100">
                    <div className="box-header-row">
                        <span>Business Hours Style</span>
                        <div className="slider-review">
                            <Slider {...sliderSettings}>
                                {headerReviewSliderImages.map((image, index) => (
                                    <div key={index}>
                                        <img src={image} alt={`slider-image-${index}`} className="slider-image" />
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>
                </div>
            </div>
            <div className="customize-width">
                <div className="onclick-custom-width px-3" onClick={toggleWidthPanel}>
                    <span>Width</span>
                    <em>{customWidth === 'auto' ? 'Auto' : `${customWidth}px`}</em>
                </div>

                <div className={`width-custom-box ${isWidthPanelOpen ? 'width-custom-box-open' : ''}`}>
                    <div className="width-custom-inner">
                        <ul>
                            <li>
                                <h6>Width</h6>
                                <button className="done-width" onClick={toggleWidthPanel}>Done</button>
                            </li>

                            <li>
                                <span>Full Width</span>
                                <div className="form-group">
                                    <input
                                        type="checkbox"
                                        id="layout_full_width_toggle"
                                        className="chkbx-toggle"
                                        checked={isFullWidth}
                                        onChange={handleFullWidthToggle}
                                    />
                                    <label htmlFor="layout_full_width_toggle"></label>
                                </div>
                            </li>

                            {!isFullWidth && (
                                <li>
                                    <span>Custom Width</span> <em>{customWidth === 'auto' ? 'Auto' : `${customWidth}px`}</em>
                                    <div className="slider-container">
                                        <input
                                            type="range"
                                            min="300"
                                            max="1200"
                                            value={customWidth}
                                            onChange={handleSliderChange}
                                        />
                                        <div className="value"><span>{customWidth === 'auto' ? 'Auto' : `${customWidth}px`}</span></div>
                                        <div className="widht-1200">1200px</div>
                                    </div>
                                </li>
                            )}
                        </ul>
                        <i className="fa fa-sort-desc" aria-hidden="true"></i>
                    </div>
                </div>
            </div>
            <div className="side-baar-box-header">
                <div className="box-header-row">
                    <span>Alignment</span>
                    <div className="left-cnater-right-button">
                        <label className="card-radio-btn">
                            <input type="radio" name="alignment_type" className="card-input-element d-none" value="left" onChange={handleActiveAlignmentInputChange} checked={activeAlignmentSection === "left"} />
                            <div className="card card-body">
                                <div className="content_sub">Left</div>
                            </div>
                        </label>
                        <label className="card-radio-btn">
                            <input type="radio" name="alignment_type" className="card-input-element d-none" value="center" onChange={handleActiveAlignmentInputChange} checked={activeAlignmentSection === "center"} />
                            <div className="card card-body">
                                <div className="content_sub">Center</div>
                            </div>
                        </label>
                        <label className="card-radio-btn">
                            <input type="radio" name="alignment_type" className="card-input-element d-none" value="right" onChange={handleActiveAlignmentInputChange} checked={activeAlignmentSection === "right"} />
                            <div className="card card-body">
                                <div className="content_sub">Right</div>
                            </div>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LayoutTab;